import React from 'react';
import Card from './components/Card'
const App = () => {
  return <div className='w-full bg-[#b1a29d] h-screen flex items-center justify-center '>

    <Card></Card>
  </div>
};

export default App;
